import { render, staticRenderFns } from "./PublishingStatementsReadOnly.vue?vue&type=template&id=0f57c181"
import script from "./PublishingStatementsReadOnly.vue?vue&type=script&lang=js"
export * from "./PublishingStatementsReadOnly.vue?vue&type=script&lang=js"
import style0 from "./PublishingStatementsReadOnly.vue?vue&type=style&index=0&id=0f57c181&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports